import React from "react";
import {
  Button,
  Modal
} from "@sainsburys-tech/fable";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { AlertCircleFilled, NewWindow } from '@sainsburys-tech/icons'

const StoreZoneEditModal = props => (
  <Modal 
    isOpen={props.open} 
    onClose={props.onClose}
    header={{ title: `Are you sure you want to edit ${props.zoneToEdit.name}?`, as: "h3" }}
  >
    <div className="fable:mb-16">
      <AlertCircleFilled className="fable:mb-8 fable:text-red-600" />
      <br />
      <p>
        Scene values for {props.zoneToEdit.name} will be lost if the zone is
        edited. Please make a note of the current scene values if needed before
        proceeding.
      </p>
    </div>
    <Link
      to={{
        pathname: `/lighting/stores/${props.storeId}/zones/${props.zoneToEdit.zoneId}/scene-levels`
      }}
      target="_blank"
      className="fable:no-underline"
    >
      <Button variant="text">
        <span className="fable:flex fable:items-center">
          <span className="fable:mr-4">↗</span>
          View {props.zoneToEdit.name} scene values
        </span>
      </Button>
    </Link>
    <div className="fable:mt-16">
      <Button onClick={props.onEdit} className="fable:mr-8">
        Edit zone
      </Button>
      <Button variant="secondary" onClick={props.onClose}>
        Cancel
      </Button>
    </div>
  </Modal>
);

export default StoreZoneEditModal;

StoreZoneEditModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  storeId: PropTypes.string,
  zoneToEdit: PropTypes.shape({
    zoneId: PropTypes.string,
    name: PropTypes.string
  })
};
